var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31038 2.66667C8.31038 4.13943 7.11648 5.33333 5.64372 5.33333C4.17096 5.33333 2.97705 4.13943 2.97705 2.66667C2.97705 1.19391 4.17096 0 5.64372 0C7.11648 0 8.31038 1.19391 8.31038 2.66667ZM10.3104 9.33333C10.3104 10.8061 8.22105 12 5.64372 12C3.06639 12 0.977051 10.8061 0.977051 9.33333C0.977051 7.86057 3.06639 6.66667 5.64372 6.66667C8.22105 6.66667 10.3104 7.86057 10.3104 9.33333ZM10.9771 6.5C10.7009 6.5 10.4771 6.27614 10.4771 6V5.16667H9.64372C9.36757 5.16667 9.14372 4.94281 9.14372 4.66667C9.14372 4.39052 9.36757 4.16667 9.64372 4.16667H10.4771V3.33333C10.4771 3.05719 10.7009 2.83333 10.9771 2.83333C11.2532 2.83333 11.4771 3.05719 11.4771 3.33333V4.16667H12.3104C12.5865 4.16667 12.8104 4.39052 12.8104 4.66667C12.8104 4.94281 12.5865 5.16667 12.3104 5.16667H11.4771V6C11.4771 6.27614 11.2532 6.5 10.9771 6.5Z",
    fill: "#00535C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.3c4c2602.svg";
export { ForwardRef as ReactComponent };